import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";

/**
 * `reportWebVitals` is gone.
 *
 * CRA ships it wired to nothing — it measured LCP and CLS and then handed them
 * to an empty callback, so it was a kilobyte of library and a bundle entry to
 * compute numbers that were immediately discarded. If these ever need
 * measuring, they should go somewhere that can read them.
 */
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
